'use client'

import { BaseTile } from '@src/components/BaseTile/BaseTile'
import { cn } from '@src/utils/tailwind'

import type { LinkTileProps } from './LinkTile.props'

export const LinkTile = (props: LinkTileProps) => {
  const {
    title = '',
    violator,
    imageUrl = '',
    href = '#',
    description,
    layout = 'column',
    rounded = 'large',
    className = '',
    columns,
    fluid,
    compact = false,
    isFavoritable,
    showFavorite,
    isFavorited,
    showShare,
    shareUrl,
    onFavoriteClick,
    onShareClick,
    openInNewTab,
    onClick,
  } = props
  return (
    <BaseTile.Provider
      title={title}
      violator={violator}
      imageUrl={imageUrl}
      href={href}
      description={description}
      layout={layout}
      rounded={rounded}
      className={cn(
        className,
        compact && [
          'lg:min-w-40! lg:max-w-40!',
          '[&_img]:lg:h-27.25! [&_img]:lg:w-40! [&_img]:lg:min-w-40!',
          '[&_.relative]:lg:h-27.25! [&_.relative]:lg:w-40! [&_.relative]:lg:min-w-40!',
        ]
      )}
      columns={columns}
      fluid={fluid}
      isFavoritable={isFavoritable}
      showFavorite={showFavorite}
      isFavorited={isFavorited}
      showShare={showShare}
      shareUrl={shareUrl}
      onFavoriteClick={onFavoriteClick}
      onShareClick={onShareClick}
      openInNewTab={openInNewTab}
      onClick={onClick}
    >
      <BaseTile.Link>
        <BaseTile.Thumbnail>
          <BaseTile.Image />
        </BaseTile.Thumbnail>
        <BaseTile.Content>
          <BaseTile.Violator />
          <BaseTile.Title
            className={compact ? 'text-body-md! font-medium! text-bodi-white!' : undefined}
          />
          <BaseTile.Description />
          <BaseTile.Actions />
        </BaseTile.Content>
      </BaseTile.Link>
    </BaseTile.Provider>
  )
}
